<script setup>
import Logo from "@/components/base/Logo.vue";
import { handleAnchorClick } from "@/utils/scrollToAnchor";
</script>

<template>
  <footer class="flex flex-col">
    <div class="footer-top flex">
      <Logo/>
      <div class="flex">
        <div class="footer-col" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">
          <h4 class="text-l">Menu</h4>
          <div class="flex flex-col" >
            <a href="#who-we-are" @click="handleAnchorClick('#who-we-are')" >Who We Are</a>
            <a href="#what-we-do" @click="handleAnchorClick('#what-we-do')">What We Do</a>
            <a href="#why-choose-galazia" @click="handleAnchorClick('#why-choose-galazia')">Why Choose Galazia</a>
            <a href="#partners" @click="handleAnchorClick('#partners')">Partners</a>
            <a href="#contacts" @click="handleAnchorClick('#contacts')">Contacts</a>
          </div>
        </div>
        <div class="footer-col" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">
          <h4 class="text-l">Company</h4>
          <div class="flex flex-col">
            <p>Schout bij Nacht Doormanweg 40, 1st floor, Willemstad, Curaçao</p>
            <a href="mailto:info@galazia.com">info@galazia.com</a>
            <a href="tel:+420725859283">+420725859283</a>
          </div>
        </div>
      </div>
    </div>
    <p class="text-m copyright" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700" :delay="300">© 2025 Galazia B.V. All rights reserved.</p>
  </footer>
</template>

<style scoped lang="scss">
footer {
  padding: 5.556vw 8.333vw 3.472vw;
  .footer-top {
    gap: 20%;
    & > div {
      width: 100%;
      gap: 15%;
    }
  }
  .footer-col {
    width: 35%;
    h4 {
      color: rgba(255, 255, 255, 0.60);
      line-height: 104%;
    }
    a, p {
      color: #FFF;
      font-family: "Rajdhani", sans-serif;
      font-size: clamp(20px, 1.736vw, 125px);
      font-weight: 700;
      line-height: 103%;
      text-decoration: none;
    }
    a {
      white-space: nowrap;
      transition: color .3s ease;
      &:hover {
        color: #16ADFC;
      }
    }
    & > div {
      gap: clamp(15px, 1.042vw, 75px);
      margin-top: clamp(30px, 2.083vw, 150px);
    }
    & + .footer-col {
      width: clamp(381px, 26.458vw, 2000px);
      & > div {
        gap: clamp(30px, 2.083vw, 150px);
      }
    }
  }
  .copyright {
    margin: 5.903vw 0 0 auto;
    color: rgba(255, 255, 255, 0.60);
  }
}
@media (max-width: 1024px) {
  footer {
    .footer-top {
      gap: 40px;
    }
    .footer-col + .footer-col {
      width: 50%;
    }
  }
}
@media (max-width: 768px) {
  footer {
    padding: 50px 24px 41px;
    .footer-top {
      flex-direction: column;
      gap: 47px;
      & > div {
        flex-direction: column;
        gap: 85px;
      }
    }
    .footer-col {
      width: 100%;
      h4 {
        font-size: 25px;
        line-height: 26px;
      }
      a {
        width: 47%;
      }
      & > div {
        flex-wrap: wrap;
        flex-direction: row !important;
        row-gap: 20px;
        column-gap: 20px;
      }
      & + .footer-col {
        width: 100%;
      }
    }
    .copyright {
      margin: 85px 0 0;
      font-size: 18px;
      line-height: 26px;
    }
  }
}
</style>